<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มพนักงานใหม่</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ employeeInit.firstname_th }} {{ employeeInit.lastname_th }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ employeeInit.employee_code }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div style="height: calc(100% - 128px)">
        <div class="d-flex flex-column" style="height: 100%">
          <v-tabs v-model="tabs">
            <v-tab>
              ข้อมูลทั่วไป
              <span class="red--text ml-1"><strong>*</strong></span>
            </v-tab>
            <v-tab class="text-capitalize">การระบุตัวตน</v-tab>
            <v-tab class="text-capitalize">TA & Access</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs" style="height: 100%">
            <v-tab-item
              class="px-6 py-4"
              style="height: 100%; overflow-y: auto"
            >
              <div class="d-flex">
                <div class="mr-4">
                  <v-list-item-avatar rounded size="64" class="mx-0 my-0">
                    <v-img
                      v-if="uploadFilePreview"
                      style="width: 64px"
                      :src="'data:image/jpeg;base64,' + uploadFilePreview"
                      aspect-ratio="1"
                    ></v-img>
                    <v-img
                      v-else-if="employee.url_photo_identifier"
                      style="width: 64px"
                      :src="employee.url_photo_identifier"
                      aspect-ratio="1"
                    ></v-img>
                    <v-avatar v-else tile color="grey lighten-4" size="64">
                      <v-icon color="grey lighten-1" large>mdi-account</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>
                </div>
                <div class="flex-grow-1" style="position: relative">
                  <v-file-input
                    :rules="[
                      (value) =>
                        !value ||
                        value.size < 2000000 ||
                        'Image size should be less than 2 MB!',
                    ]"
                    class="fix-google-chrome"
                    v-model="fileImage"
                    ref="imgFileInput"
                    accept="image/jpeg"
                    show-size
                    @change="onFileChange"
                    @click:clear="onFileClear"
                    outlined
                    dense
                    hide-details
                  >
                  </v-file-input>
                  <v-btn
                    style="position: absolute; bottom: -5px; left: -5px"
                    :disabled="
                      !employee.url_photo_identifier ||
                      (uiCtrl &&
                        !uiCtrl.isEnable(
                          'btn:::employee:photo-identifier:delete'
                        ))
                    "
                    icon
                    class="mr-3"
                    @click="handleDeleteEmployeePhotoIdentifier"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                  <div
                    class="mt-1 caption"
                    style="position: absolute; right: 0"
                  >
                    <span>jpeg เท่านั้น, </span>
                    <span>ขนาดไฟล์ไม่เกิน 2Mb</span>
                  </div>
                </div>
              </div>

              <div>
                <v-switch
                  v-model="employee.is_active"
                  :label="employee.is_active ? 'Active' : 'Not Active'"
                >
                  <template v-slot:label>
                    <span
                      class="body-2 ml-2 grey--text text--darken-3 font-weight-medium"
                    >
                      {{ employee.is_active ? 'Active' : 'Not Active' }}
                    </span>
                  </template>
                </v-switch>
              </div>

              <div>
                <label class="body-2">
                  รหัสอ้างอิงพนักงาน
                  <span
                    v-if="company.is_employee_reference_code"
                    class="red--text"
                  >
                    <strong>*</strong>
                  </span>
                </label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  tabindex="0"
                  v-model="employee.employee_reference_code"
                  :rules="
                    company.is_employee_reference_code
                      ? [
                          (v) => !!v || 'โปรดระบุรหัสอ้างอิงพนักงาน',
                          (v) =>
                            (v && v.length >= 1 && v.length <= 32) ||
                            'รหัสพนักงานต้องอยู่ระหว่าง 1 ถึง 32 ตัวอักษร',
                        ]
                      : []
                  "
                  required
                  clearable
                  @change="checkEmpty($event, 'employee_reference_code')"
                  outlined
                  dense
                >
                </v-text-field>
              </div>

              <div>
                <label class="body-2">
                  รหัสพนักงาน
                  <span class="red--text"><strong>*</strong></span>
                </label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  tabindex="1"
                  v-model="employee.employee_code"
                  :rules="[
                    (v) => !!v || 'โปรดระบุรหัสพนักงาน',
                    (v) =>
                      (v && v.length >= 1 && v.length <= 32) ||
                      'รหัสพนักงานต้องอยู่ระหว่าง 1 ถึง 32 ตัวอักษร',
                  ]"
                  required
                  clearable
                  @change="checkEmpty($event, 'employee_code')"
                  outlined
                  dense
                >
                </v-text-field>
              </div>

              <div>
                <label class="body-2">คำนำหน้าชื่อ</label>
                <v-autocomplete
                  class="fix-google-chrome mt-1"
                  tabindex="2"
                  v-model="employee.company_prefix_uuid"
                  :items="prefixs"
                  item-text="title_th"
                  item-value="company_prefix_uuid"
                  outlined
                  dense
                >
                </v-autocomplete>
              </div>

              <div>
                <label class="body-2">
                  ชื่อ
                  <span class="red--text"><strong>*</strong></span>
                </label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  tabindex="3"
                  v-model="employee.firstname_th"
                  :rules="[
                    (v) => !!v || 'โปรดระบุชื่อ',
                    (v) =>
                      !v ||
                      (v && v.length <= 45) ||
                      'ชื่อต้องน้อยกว่า 45 ตัวอักษร',
                  ]"
                  required
                  clearable
                  @change="checkEmpty($event, 'firstname_th')"
                  outlined
                  dense
                >
                </v-text-field>
              </div>

              <div>
                <label class="body-2">
                  นามสกุล
                  <span class="red--text"><strong>*</strong></span>
                </label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  tabindex="4"
                  v-model="employee.lastname_th"
                  :rules="[
                    (v) => !!v || 'โปรดระบุนามสกุล',
                    (v) =>
                      !v ||
                      (v && v.length <= 80) ||
                      'นามสกุลต้องน้อยกว่า 80 ตัวอักษร',
                  ]"
                  required
                  clearable
                  @change="checkEmpty($event, 'lastname_th')"
                  outlined
                  dense
                >
                </v-text-field>
              </div>

              <div>
                <label class="body-2">ชื่อ (อังกฤษ)</label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  tabindex="5"
                  v-model="employee.firstname_en"
                  :rules="[
                    (v) =>
                      !v ||
                      (v && v.length <= 45) ||
                      'ชื่อต้องน้อยกว่า 45 ตัวอักษร',
                  ]"
                  clearable
                  @change="checkEmpty($event, 'firstname_en')"
                  outlined
                  dense
                ></v-text-field>
              </div>

              <div>
                <label class="body-2">นามสกุล (อังกฤษ)</label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  tabindex="6"
                  v-model="employee.lastname_en"
                  :rules="[
                    (v) =>
                      !v ||
                      (v && v.length <= 80) ||
                      'นามสกุลต้องน้อยกว่า 80 ตัวอักษร',
                  ]"
                  clearable
                  @change="checkEmpty($event, 'lastname_en')"
                  outlined
                  dense
                ></v-text-field>
              </div>

              <div>
                <label class="body-2">เพศ</label>
                <v-autocomplete
                  class="fix-google-chrome mt-1"
                  tabindex="7"
                  v-model="employee.gender_id"
                  :items="genders"
                  item-text="title_th"
                  item-value="gender_id"
                  outlined
                  dense
                >
                </v-autocomplete>
              </div>

              <div>
                <label class="body-2">เบอร์โทรศัพท์มือถือ</label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  tabindex="8"
                  v-model="employee.phone_no"
                  clearable
                  :rules="[
                    (v) =>
                      !v ||
                      /^\d+$/.test(v) ||
                      'เบอร์โทรศัพท์มือถือต้องเป็นตัวเลขเท่านั้น',
                    (v) =>
                      !v ||
                      v.charAt(0) === '0' ||
                      'เบอร์โทรศัพท์มือถือต้องขึ้นต้นด้วย 0',
                    (v) =>
                      !v ||
                      (v && v.length === 10) ||
                      'เบอร์โทรศัพท์มือถือต้องเท่ากับ 10',
                  ]"
                  @change="checkEmpty($event, 'phone_no')"
                  outlined
                  dense
                ></v-text-field>
              </div>

              <div>
                <label class="body-2">อีเมล</label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  tabindex="9"
                  v-model="employee.email"
                  clearable
                  :rules="[
                    (v) => !v || /.+@.+\..+/.test(v) || 'อีเมลไม่ถูกต้อง',
                  ]"
                  @change="checkEmpty($event, 'email')"
                  outlined
                  dense
                ></v-text-field>
              </div>

              <div v-if="company.is_ms_entraid">
                <label class="body-2">Microsoft Entra ID (email)</label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  tabindex="10"
                  v-model="employee.ms_entraid_email"
                  clearable
                  :rules="[
                    (v) => !v || /.+@.+\..+/.test(v) || 'อีเมลไม่ถูกต้อง',
                  ]"
                  @change="checkEmpty($event, 'ms_entraid_email')"
                  outlined
                  dense
                ></v-text-field>
              </div>

              <div class="mb-6">
                <label class="body-2">วันเกิด</label>
                <date-picker
                  v-model="employee.birthday"
                  class="mt-1"
                  type="date"
                  format="DD/MM/YYYY"
                  style="width: 100%"
                ></date-picker>
              </div>

              <div>
                <label class="body-2">
                  หน่วยงาน
                  <span class="red--text"><strong>*</strong></span>
                </label>
                <v-autocomplete
                  class="fix-google-chrome mt-1"
                  tabindex="11"
                  v-model="employee.organization_uuid"
                  :items="
                    organizations.map((org) => ({
                      ...org,
                      text: `${org.organization_code} - ${org.title_th}`,
                    }))
                  "
                  :rules="[(v) => !!v || 'โปรดระบุหน่วยงาน']"
                  item-text="text"
                  item-value="organization_uuid"
                  outlined
                  dense
                >
                </v-autocomplete>
              </div>

              <div>
                <label class="body-2">
                  ตำแหน่ง
                  <span class="red--text"><strong>*</strong></span>
                </label>
                <v-autocomplete
                  class="fix-google-chrome mt-1"
                  tabindex="12"
                  v-model="employee.position_uuid"
                  :items="
                    positions.map((pos) => ({
                      ...pos,
                      text: `${pos.position_code} - ${pos.title_th}`,
                    }))
                  "
                  :rules="[(v) => !!v || 'โปรดระบุตำแหน่ง']"
                  item-text="text"
                  item-value="position_uuid"
                  outlined
                  dense
                >
                </v-autocomplete>
              </div>

              <div>
                <label class="body-2">
                  ประเภทพนักงาน
                  <span class="red--text"><strong>*</strong></span>
                </label>
                <v-autocomplete
                  class="fix-google-chrome mt-1"
                  tabindex="13"
                  v-model="employee.employee_type_uuid"
                  :items="
                    employeeTypes.map((empType) => ({
                      ...empType,
                      text: `${empType.employee_type_code} - ${empType.title_th}`,
                    }))
                  "
                  :rules="[(v) => !!v || 'โปรดระบุประเภทพนักงาน']"
                  item-text="text"
                  item-value="employee_type_uuid"
                  outlined
                  dense
                >
                </v-autocomplete>
              </div>

              <div>
                <label class="body-2">
                  กะทำงาน
                  <span class="red--text"><strong>*</strong></span>
                </label>
                <v-autocomplete
                  class="fix-google-chrome mt-1"
                  tabindex="14"
                  v-model="employee.shift_uuid"
                  :items="
                    shifts.map((sh) => ({
                      ...sh,
                      text: `${sh.shift_code} - ${sh.title_th}`,
                    }))
                  "
                  :rules="[(v) => !!v || 'โปรดระบุกะทำงาน']"
                  item-text="text"
                  item-value="shift_uuid"
                  outlined
                  dense
                >
                </v-autocomplete>
              </div>

              <div>
                <label class="body-2">ระดับพนักงาน</label>
                <v-autocomplete
                  class="fix-google-chrome mt-1"
                  tabindex="15"
                  v-model="employee.employee_level_uuid"
                  :items="
                    employeeLevels
                      .map((item) => ({
                        ...item,
                        text: `${item.employee_level_code} - ${item.title_th}`,
                      }))
                      .sort((a, b) =>
                        a.employee_level_code.localeCompare(
                          b.employee_level_code
                        )
                      )
                  "
                  item-text="text"
                  item-value="employee_level_uuid"
                  outlined
                  dense
                  autocomplete="new-password"
                  name="ignore-autofill"
                  id="ignore-autofill"
                >
                </v-autocomplete>
              </div>

              <div v-if="formAction === 'edit'" class="mb-6">
                <label class="body-2">วันที่ลาออก</label>
                <date-picker
                  v-model="employee.resign_date"
                  class="mt-1"
                  type="date"
                  format="DD/MM/YYYY"
                  style="width: 100%"
                ></date-picker>
              </div>

              <div v-if="formAction === 'edit'" class="mt-6">
                <p class="mb-0 body-2">รหัสผ่าน</p>
                <v-btn
                  :disabled="
                    uiCtrl &&
                    !uiCtrl.isEnable('btn:::employee:password:reset:post')
                  "
                  @click="handleEmployeeResetPassword"
                  class="mt-1"
                >
                  <v-icon left v-if="isResetPassword" color="primary">
                    mdi-autorenew
                  </v-icon>
                  <v-icon left v-else>mdi-key</v-icon>
                  {{
                    isResetPassword ? 'กำลังรีเซ็ตรหัสผ่าน' : 'รีเซ็ตรหัสผ่าน'
                  }}
                </v-btn>
              </div>
            </v-tab-item>
            <v-tab-item
              class="px-6 py-4"
              style="height: 100%; overflow-y: auto"
            >
              <div>
                <label class="body-2">Serial Card</label>
                <v-text-field
                  v-model="employee.card.sn"
                  :rules="[
                    (v) =>
                      !v ||
                      /^[0-9A-Za-z]+$/.test(v) ||
                      'ใส่ได้เฉพาะตัวเลขและตัวอักษร',
                    (v) =>
                      !v ||
                      (v && v.length <= 32) ||
                      'หมายเลขบัตรต้องน้อยกว่าหรือเท่ากับ 32 ตัวอักษร',
                  ]"
                  class="fix-google-chrome mt-1"
                  clearable
                  outlined
                  dense
                  :error="!serialValid"
                  :error-messages="serialMessageError"
                  ref="serialInput"
                  @input="handleSerialChange"
                >
                </v-text-field>
              </div>

              <div>
                <label class="body-2">Pin Code</label>
                <v-text-field
                  class="fix-google-chrome mt-1"
                  v-model="employee.pin_code"
                  :rules="[
                    (v) => !v || /^\d+$/.test(v) || 'ต้องเป็นตัวเลขเท่านั้น',
                    (v) =>
                      !v ||
                      /^\d{4}$/.test(v) ||
                      'Pin Code ต้องเท่ากับ 4 ตัวอักษร',
                  ]"
                  clearable
                  outlined
                  dense
                  autocomplete="new-password"
                  name="ignore-autofill-pin-code"
                  id="ignore-autofill-pin-code"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
              </div>

              <div>
                <label class="body-2">รูปแบบการระบุตัวตน</label>
                <v-autocomplete
                  v-model="employee.identify_mode"
                  class="fix-google-chrome mt-1"
                  :items="identifyModes"
                  item-text="title_th"
                  item-value="identify_mode"
                  outlined
                  dense
                  :disabled="
                    uiCtrl &&
                    !uiCtrl.isEnable(
                      'select:::identify-mode:hardware:model:update'
                    )
                  "
                >
                </v-autocomplete>
              </div>

              <v-card
                v-for="biometric in biometrics"
                :key="biometric.biometric_code"
                style="cursor: pointer"
                class="mt-1 pa-2 d-flex justify-space-between"
                outlined
                @click="handleOnClickBiometric(biometric)"
              >
                <div class="d-flex">
                  <v-avatar size="40">
                    <img
                      class="biometric-icon"
                      :src="biometric.icon_image_url"
                      alt="image"
                    />
                  </v-avatar>
                  <div class="ml-2">
                    <div>
                      {{ biometric.title_th }}
                    </div>
                    <div style="font-size: 12px">
                      <span
                        :class="
                          biometric.min &&
                          (employeeBiometric.find(
                            (e) => e.biometric_code === biometric.biometric_code
                          )?.biometric_property?.length || 0) >= biometric.min
                            ? 'grey--text'
                            : 'red--text'
                        "
                        >{{
                          employeeBiometric.find(
                            (e) => e.biometric_code === biometric.biometric_code
                          )?.biometric_property?.length || 0
                        }}
                        / {{ biometric.biometric_property.length }}</span
                      >
                      <span> {{ biometric.title_th }}</span>
                    </div>
                  </div>
                </div>
                <v-icon>mdi-chevron-right</v-icon>
              </v-card>
            </v-tab-item>
            <v-tab-item
              class="px-6 py-4"
              style="height: 100%; overflow-y: auto"
            >
              <div>
                <!-- <p class="mb-2">ข้อมูล Time Attendance</p> -->
                <div class="mb-6">
                  <label class="body-2 mb-1">วันเวลาเริ่มใช้งาน</label>
                  <date-picker
                    v-model="employee.time_attendance_start_time"
                    type="datetime"
                    format="DD/MM/YYYY HH:mm"
                    style="width: 100%"
                  ></date-picker>
                </div>
                <div class="mb-6">
                  <label class="body-2 mb-1">วันเวลาสิ้นสุดใช้งาน</label>
                  <date-picker
                    v-model="employee.time_attendance_end_time"
                    type="datetime"
                    format="DD/MM/YYYY HH:mm"
                    style="width: 100%"
                  ></date-picker>
                </div>
                <div v-if="formAction === 'add'">
                  <label class="body-2 mr-4">กลุ่มสิทธิ์ (TA & Access)</label>
                  <v-autocomplete
                    v-model="accessAuthoritiesSelected"
                    class="fix-google-chrome mt-1"
                    :items="
                      accessAuthorities.map((item) => ({
                        ...item,
                        title_th: `${item.authority_code} - ${item.title_th}`,
                      }))
                    "
                    :disabled="
                      uiCtrl &&
                      !uiCtrl.isEnable('select:::employee_to_authority:get')
                    "
                    item-text="title_th"
                    item-value="authority_uuid"
                    outlined
                    dense
                    chips
                    small-chips
                    multiple
                  >
                  </v-autocomplete>
                </div>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isEmployeeDataChange && formAction === 'edit'"
        >
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::employee:delete')"
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::employee:create')"
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::employee:update')"
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <ConfirmDialog
      :dialog="confirmDialogResetPassword"
      :dialogData="confirmDialogDataResetPassword"
      @cancelConfirmDialog="cancelConfirmDialogResetPassword"
      @submitConfirmDialog="submitConfirmDialogResetPassword"
    />
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDeleteEmployeePhotoIdentifier"
      :loading="confirmDialogDeleteEmployeePhotoIdentifierLoading"
      :dialogData="confirmDialogDeleteEmployeePhotoIdentifierData"
      @cancelConfirmDialog="cancelConfirmDialogDeleteEmployeePhotoIdentifier"
      @submitConfirmDialog="submitConfirmDialogDeleteEmployeePhotoIdentifier"
    />
  </v-navigation-drawer>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { mapActions } from 'vuex'

export default {
  name: 'EmployeeForm',
  components: { ConfirmDialog, DatePicker },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    employee: {
      type: Object,
    },
    employeeInit: {
      type: Object,
    },
  },
  data() {
    return {
      showPassword: false,
      serialValid: true,
      serialMessageError: '',
      tabs: 0,
      fileImage: null,
      uploadFilePreview: null,
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      isResetPassword: false,
      confirmDialogResetPassword: false,
      confirmDialogDataResetPassword: {},
      confirmDialogDeleteEmployeePhotoIdentifier: false,
      confirmDialogDeleteEmployeePhotoIdentifierLoading: false,
      confirmDialogDeleteEmployeePhotoIdentifierData: {},

      accessAuthoritiesSelected: [],
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    company() {
      return this.$store.state.company.company
    },
    organizations() {
      return this.$store.state.organization.organizations
    },
    positions() {
      return this.$store.state.position.positions
    },
    employeeLevels() {
      return this.$store.state.employeeLevel.employeeLevels
    },
    employeeTypes() {
      return this.$store.state.employeeType.employeeTypes
    },
    shifts() {
      return this.$store.state.shift.shifts
    },
    genders() {
      return this.$store.state.gender.genders
    },
    prefixs() {
      return this.$store.state.prefix.prefixs
    },
    biometrics() {
      return this.$store.state.employee.biometrics
    },
    employeeBiometric() {
      return this.$store.state.employee.employeeBiometric
    },
    identifyModes() {
      return this.$store.state.hardware.identifyModes
    },
    accessAuthorities() {
      return this.$store.state.accessAuthority.accessAuthorities
    },
    isTabEmployeeGeneralDataChange() {
      if (
        this.fileImage ||
        this.employee.is_active !== this.employeeInit.is_active ||
        this.employee.employee_reference_code !==
          this.employeeInit.employee_reference_code ||
        this.employee.employee_code !== this.employeeInit.employee_code ||
        this.employee.company_prefix_uuid !==
          this.employeeInit.company_prefix_uuid ||
        this.employee.firstname_th !== this.employeeInit.firstname_th ||
        this.employee.lastname_th !== this.employeeInit.lastname_th ||
        this.employee.firstname_en !== this.employeeInit.firstname_en ||
        this.employee.lastname_en !== this.employeeInit.lastname_en ||
        this.employee.gender_id !== this.employeeInit.gender_id ||
        this.employee.phone_no !== this.employeeInit.phone_no ||
        this.employee.email !== this.employeeInit.email ||
        this.employee.ms_entraid_email !== this.employeeInit.ms_entraid_email ||
        this.employee.birthday !== this.employeeInit.birthday ||
        this.employee.organization_uuid !==
          this.employeeInit.organization_uuid ||
        this.employee.position_uuid !== this.employeeInit.position_uuid ||
        this.employee.employee_level_uuid !==
          this.employeeInit.employee_level_uuid ||
        this.employee.employee_type_uuid !==
          this.employeeInit.employee_type_uuid ||
        this.employee.shift_uuid !== this.employeeInit.shift_uuid ||
        this.employee.employee_level_code !==
          this.employeeInit.employee_level_code ||
        this.employeeInit.resign_date !== this.employee.resign_date
      ) {
        return true
      } else {
        return false
      }
    },
    isTabEmployeeIdentityDataChange() {
      if (
        this.employee.card.sn !== this.employeeInit.card.sn ||
        this.employee.pin_code !== this.employeeInit.pin_code ||
        this.employee.identify_mode !== this.employeeInit.identify_mode ||
        JSON.stringify(this.employeeInit.biometric) !==
          JSON.stringify(this.employeeBiometric)
      ) {
        return true
      } else {
        return false
      }
    },
    isTabEmployeeTimeAttendanceDataChange() {
      if (
        this.employee?.time_attendance_start_time?.toString() !==
          this.employeeInit?.time_attendance_start_time?.toString() ||
        this.employee?.time_attendance_end_time?.toString() !==
          this.employeeInit?.time_attendance_end_time?.toString()
      ) {
        return true
      } else {
        return false
      }
    },
    isAccessAuthorityDataChange() {
      if (this.accessAuthoritiesSelected.length) {
        return true
      } else {
        return false
      }
    },
    isEmployeeDataChange() {
      if (
        this.isTabEmployeeGeneralDataChange ||
        this.isTabEmployeeIdentityDataChange ||
        this.isTabEmployeeTimeAttendanceDataChange ||
        this.isAccessAuthorityDataChange
      ) {
        this.$emit('isEmployeeDataChange', true)
        return true
      } else {
        this.$emit('isEmployeeDataChange', false)
        return false
      }
    },
  },
  methods: {
    ...mapActions({
      verifyCardSerialNumber: 'card/verifyCardSerialNumber',
      fetchCardTypes: 'card/fetchCardTypes',
      addCard: 'card/addCard',
      editCard: 'card/editCard',
      deleteCard: 'card/deleteCard',
      addEmployee: 'employee/addEmployee',
      editEmployee: 'employee/editEmployee',
      deleteEmployee: 'employee/deleteEmployee',
      deleteEmployeePhotoIdentifier: 'employee/deleteEmployeePhotoIdentifier',
      addEmployeeToAuthorities: 'employee/addEmployeeToAuthorities',
    }),
    handleDeleteEmployeePhotoIdentifier() {
      this.confirmDialogDeleteEmployeePhotoIdentifier = true
      this.confirmDialogDeleteEmployeePhotoIdentifierData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบรูป Profile',
        value: '',
        item: '',
      }
    },
    cancelConfirmDialogDeleteEmployeePhotoIdentifier() {
      this.confirmDialogDeleteEmployeePhotoIdentifier = false
    },
    submitConfirmDialogDeleteEmployeePhotoIdentifier() {
      this.confirmDialogDeleteEmployeePhotoIdentifierLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        employee_uuid: this.employee.employee_uuid,
      }

      this.deleteEmployeePhotoIdentifier(payload)
        .then(() => {
          this.confirmDialogDeleteEmployeePhotoIdentifierLoading = false
          this.confirmDialogDeleteEmployeePhotoIdentifier = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.employee.url_photo_identifier = null

          this.$store.commit('employee/EDIT_EMPLOYEE', { ...this.employee })
        })
        .catch((error) => {
          this.confirmDialogDeleteEmployeePhotoIdentifierLoading = false

          if (error.response && error.response.status === 403) {
            this.dialogForbidden = true
            return
          }

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบพนักงาน',
        value: `${this.employee.employee_code} : ${this.employee.firstname_th} ${this.employee.lastname_th}`,
        item: this.employee,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    async submitConfirmDialogDelete(employee) {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.confirmDialogDeleteLoading = true

        await this.deleteEmployee({
          company_uuid,
          employee_uuid: employee.employee_uuid,
        })

        this.confirmDialogDeleteLoading = false
        this.confirmDialogDelete = false

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)

        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.resetValidation()
      } catch (error) {
        this.confirmDialogDeleteLoading = false

        if (error.response && error.response.status === 403) {
          this.dialogForbidden = true
          return
        }

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    handleEmployeeResetPassword() {
      this.confirmDialogResetPassword = true
      this.confirmDialogDataResetPassword = {
        title: 'ต้องการรีเซ็ตรหัสผ่านพนักงานหรือไม่ ?',
        text: 'รหัสผ่านของพนักงานจะถูกรีเซ็ตให้ตรงกับรหัสพนักงาน',
        negativeBtn: 'รีเซ็ตรหัสผ่าน',
      }
    },
    cancelConfirmDialogResetPassword() {
      this.confirmDialogResetPassword = false
    },
    submitConfirmDialogResetPassword() {
      this.confirmDialogResetPassword = false
      this.isResetPassword = true

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        employee_uuid: this.employee.employee_uuid,
      }

      this.$store
        .dispatch('employee/resetEmployeePassword', payload)
        .then(() => {
          this.isResetPassword = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'การรีเซ็ตรหัสผ่านของพนักงานสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
        .catch((error) => {
          this.isResetPassword = false

          if (error.response && error.response.status === 403) {
            this.dialogForbidden = true
            return
          }

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.onReset()
    },
    checkEmpty(value, field) {
      if (value) {
        this.employee[field] = value.trim()
      }
    },
    handleSerialChange() {
      this.serialValid = true
      this.serialMessageError = ''
    },
    handleOnClickBiometric(biometric) {
      this.$emit('onClickBiometric', biometric)
    },
    async onFileChange(file) {
      if (file) {
        this.fileImage = file
        const result = await this.getBase64(file)
        this.uploadFilePreview = result.split(',').pop()
      }
    },
    onFileClear() {
      this.fileImage = null
      this.uploadFilePreview = null
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    },
    async onSubmit() {
      if (
        !this.employee.employee_code ||
        !this.employee.firstname_th ||
        !this.employee.lastname_th ||
        !this.employee.organization_uuid ||
        !this.employee.position_uuid ||
        !this.employee.employee_type_uuid ||
        !this.employee.shift_uuid
      ) {
        this.tabs = 0
        this.$refs?.form.validate()

        return
      }

      if (this.$refs?.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          // verify card serial number
          if (this.employee.card.sn) {
            const cardSerialNumber = this.employee.card.sn.trim()
            const verifyPayload = {
              body: {
                company_uuid,
                serial_number: cardSerialNumber,
              },
            }
            const verifyResult = await this.verifyCardSerialNumber(
              verifyPayload
            )
            if (!_.isEmpty(verifyResult.employee)) {
              this.$store.state.loading = false

              this.serialValid = false
              this.serialMessageError =
                'หมายเลขบัตรนี้มีผู้ใช้แล้ว กรุณาเปลี่ยนหมายเลขบัตร'

              this.tabs = 1

              this.$nextTick(() => {
                this.$refs.serialInput.focus()
              })
              return
            }
          }

          let file_base64 = null
          let file_ext = null

          if (this.fileImage) {
            const result = await this.getBase64(this.fileImage)
            file_base64 = result.split(',').pop()
            file_ext = `.${this.fileImage.type.split('/').pop()}`
          }

          const newEmployee = {
            photo_identifier_extension: file_ext ? file_ext : null,
            photo_identifier: file_base64 ? file_base64 : null,
            organization_uuid: this.employee.organization_uuid,
            position_uuid: this.employee.position_uuid,
            employee_level_uuid: this.employee.employee_level_uuid || null,
            employee_type_uuid: this.employee.employee_type_uuid,
            shift_uuid: this.employee.shift_uuid,
            employee_code: this.employee.employee_code,
            employee_reference_code:
              this.employee.employee_reference_code || null,
            ms_entraid_email: this.employee.ms_entraid_email || null,
            pin_code: this.employee.pin_code || null,
            firstname_th: this.employee.firstname_th,
            lastname_th: this.employee.lastname_th,
            firstname_en: this.employee.firstname_en
              ? this.employee.firstname_en
              : null,
            lastname_en: this.employee.lastname_en
              ? this.employee.lastname_en
              : null,
            gender_id: this.employee.gender_id || null,
            company_prefix_uuid: this.employee.company_prefix_uuid || null,
            phone_no: this.employee.phone_no ? this.employee.phone_no : null,
            email: this.employee.email ? this.employee.email : null,
            birthday: this.employee.birthday
              ? moment(this.employee.birthday).format('YYYY-MM-DD')
              : null,
            time_attendance_start_time: this.employee.time_attendance_start_time
              ? moment(this.employee.time_attendance_start_time).format()
              : null,
            time_attendance_end_time: this.employee.time_attendance_end_time
              ? moment(this.employee.time_attendance_end_time).format()
              : null,
            role_uuid: this.$store.state.role.roles[0].role_uuid,
            identify_mode:
              this.employee.identify_mode || this.employee.identify_mode === 0
                ? this.employee.identify_mode
                : 8,
            is_active: this.employee.is_active,
          }

          const { employee_uuid } = await this.addEmployee({
            company_uuid,
            employee: newEmployee,
          })

          const cardApiPostList = []
          if (this.employee.card.sn) {
            await this.fetchCardTypes({
              company_uuid,
              params: {
                dpc: 'employee-to-list-card-type',
              },
            })

            const cardTypes = this.$store.state.card.cardTypes
            const defaultEmployeeCard = cardTypes.find(
              (cardType) => cardType.is_default_for_employee_card
            )

            cardApiPostList.push(
              this.addCard({
                company_uuid,
                body: {
                  employee_uuid,
                  card_type_uuid: defaultEmployeeCard?.card_type_uuid || null,
                  card_material_code: null,
                  card_number: null,
                  card_identifiers: [
                    {
                      card_identifier_type_code:
                        defaultEmployeeCard?.default_card_identifier_type_code ||
                        null,
                      sn: {
                        base_10: null,
                        base_16: null,
                        string: this.employee.card.sn,
                      },
                      default_display_encoding: {
                        sn_base_10: false,
                        sn_base_16: false,
                        sn_string: true,
                      },
                      is_base_10_16_locked: true,
                      issue_datetime: null,
                      expire_datetime: null,
                      freeze_datetime: null,
                      discard_datetime: null,
                    },
                  ],
                },
              })
            )
          }

          const biometricApiPutList = []
          const faceBiometric =
            this.$store.state.employee.employeeBiometric.find(
              (e) => e.biometric_code === 'face'
            )
          if (faceBiometric) {
            faceBiometric.biometric_property.forEach((face) => {
              biometricApiPutList.push(
                this.$store.dispatch('employee/addEmployeeBiometric', {
                  company_uuid,
                  employee_uuid,
                  biometric_property_code: face.biometric_property_code,
                  body: {
                    ...face.employee_biometric,
                  },
                })
              )
            })
          }

          const fingerBiometric =
            this.$store.state.employee.employeeBiometric.find(
              (e) => e.biometric_code === 'fingerprint_secugen'
            )
          if (fingerBiometric) {
            fingerBiometric.biometric_property.forEach((finger) => {
              biometricApiPutList.push(
                this.$store.dispatch('employee/addEmployeeBiometric', {
                  company_uuid,
                  employee_uuid,
                  biometric_property_code: finger.biometric_property_code,
                  body: {
                    ...finger.employee_biometric,
                  },
                })
              )
            })
          }

          const accessAuthoritiesApiPostList = []
          if (this.accessAuthoritiesSelected.length > 0) {
            accessAuthoritiesApiPostList.push(
              this.addEmployeeToAuthorities({
                company_uuid,
                body: {
                  employee_uuid,
                  authority_uuids: [...this.accessAuthoritiesSelected],
                },
              })
            )
          }

          await Promise.all([
            ...cardApiPostList,
            ...biometricApiPutList,
            ...accessAuthoritiesApiPostList,
          ])

          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'เพิ่มข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.fileImage = null
          this.uploadFilePreview = null
          this.serialValid = true
          this.serialMessageError = ''

          this.accessAuthoritiesSelected = []

          this.$emit('formActionCompleted', this.formAction)
        } catch (error) {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    async onSave() {
      if (
        !this.employee.employee_code ||
        !this.employee.firstname_th ||
        !this.employee.lastname_th ||
        !this.employee.organization_uuid ||
        !this.employee.position_uuid ||
        !this.employee.employee_type_uuid ||
        !this.employee.shift_uuid
      ) {
        this.tabs = 0
        this.$refs?.form.validate()

        return
      }

      if (this.$refs?.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          // verify card serial number
          if (
            this.employeeInit.card.sn !== this.employee.card.sn &&
            this.employee.card.sn
          ) {
            const cardSerialNumber = this.employee.card.sn.trim()
            const verifyPayload = {
              body: {
                company_uuid,
                serial_number: cardSerialNumber,
              },
            }
            const verifyResult = await this.verifyCardSerialNumber(
              verifyPayload
            )
            if (!_.isEmpty(verifyResult.employee)) {
              this.$store.state.loading = false

              this.serialValid = false
              this.serialMessageError =
                'หมายเลขบัตรนี้มีผู้ใช้แล้ว กรุณาเปลี่ยนหมายเลขบัตร'

              this.tabs = 1

              this.$nextTick(() => {
                this.$refs.serialInput.focus()
              })
              return
            }
          }

          let file_base64 = null
          let file_ext = null

          if (this.fileImage) {
            const result = await this.getBase64(this.fileImage)
            file_base64 = result.split(',').pop()
            file_ext = `.${this.fileImage.type.split('/').pop()}`
          }

          const updatedEmployee = {
            photo_identifier_extension: file_ext ? file_ext : null,
            photo_identifier: file_base64 ? file_base64 : null,
            organization_uuid: this.employee.organization_uuid,
            position_uuid: this.employee.position_uuid,
            employee_level_uuid: this.employee.employee_level_uuid || null,
            employee_type_uuid: this.employee.employee_type_uuid,
            shift_uuid: this.employee.shift_uuid,
            employee_code: this.employee.employee_code,
            employee_reference_code:
              this.employee.employee_reference_code || null,
            ms_entraid_email: this.employee.ms_entraid_email || null,
            pin_code: this.employee.pin_code || null,
            firstname_th: this.employee.firstname_th,
            lastname_th: this.employee.lastname_th,
            firstname_en: this.employee.firstname_en
              ? this.employee.firstname_en
              : null,
            lastname_en: this.employee.lastname_en
              ? this.employee.lastname_en
              : null,
            gender_id: this.employee.gender_id || null,
            company_prefix_uuid: this.employee.company_prefix_uuid || null,
            phone_no: this.employee.phone_no ? this.employee.phone_no : null,
            email: this.employee.email ? this.employee.email : null,
            birthday: this.employee.birthday
              ? moment(this.employee.birthday).format('YYYY-MM-DD')
              : null,
            resign_date: this.employee.resign_date
              ? moment(this.employee.resign_date).format('YYYY-MM-DD')
              : null,
            time_attendance_start_time: this.employee.time_attendance_start_time
              ? moment(this.employee.time_attendance_start_time).format()
              : null,
            time_attendance_end_time: this.employee.time_attendance_end_time
              ? moment(this.employee.time_attendance_end_time).format()
              : null,
            role_uuid: this.$store.state.role.roles[0].role_uuid,
            identify_mode:
              this.employee.identify_mode || this.employee.identify_mode === 0
                ? this.employee.identify_mode
                : 8,
            is_active: this.employee.is_active,
          }

          const employeeApiPutList = []
          if (
            this.isTabEmployeeGeneralDataChange ||
            this.isTabEmployeeTimeAttendanceDataChange ||
            this.employee.pin_code !== this.employeeInit.pin_code ||
            this.employee.identify_mode !== this.employeeInit.identify_mode
          ) {
            // edit employee
            employeeApiPutList.push(
              this.editEmployee({
                company_uuid,
                employee_uuid: this.employee.employee_uuid,
                employee: updatedEmployee,
              })
            )
          }

          const cardApiPutList = []
          if (!this.employeeInit.card.sn && this.employee.card.sn) {
            // add card
            await this.fetchCardTypes({
              company_uuid,
              params: {
                dpc: 'employee-to-list-card-type',
              },
            })

            const cardTypes = this.$store.state.card.cardTypes
            const defaultEmployeeCard = cardTypes.find(
              (cardType) => cardType.is_default_for_employee_card
            )

            cardApiPutList.push(
              this.addCard({
                company_uuid,
                body: {
                  employee_uuid: this.employee.employee_uuid,
                  card_type_uuid: defaultEmployeeCard?.card_type_uuid,
                  card_material_code: null,
                  card_number: null,
                  card_identifiers: [
                    {
                      card_identifier_type_code:
                        defaultEmployeeCard?.default_card_identifier_type_code,
                      sn: {
                        base_10: null,
                        base_16: null,
                        string: this.employee.card.sn,
                      },
                      default_display_encoding: {
                        sn_base_10: false,
                        sn_base_16: false,
                        sn_string: true,
                      },
                      is_base_10_16_locked: true,
                      issue_datetime: null,
                      expire_datetime: null,
                      freeze_datetime: null,
                      discard_datetime: null,
                    },
                  ],
                },
              })
            )
          }

          if (
            this.employeeInit.card.sn &&
            this.employeeInit.card.sn !== this.employee.card.sn
          ) {
            // edit card
            await this.fetchCardTypes({
              company_uuid,
              params: {
                dpc: 'employee-to-list-card-type',
              },
            })

            const cardTypes = this.$store.state.card.cardTypes
            const defaultEmployeeCard = cardTypes.find(
              (cardType) => cardType.is_default_for_employee_card
            )

            cardApiPutList.push(
              this.editCard({
                company_uuid,
                card_uuid: this.employee.card.card_uuid,
                body: {
                  employee_uuid: this.employee.employee_uuid,
                  card_type_uuid: defaultEmployeeCard?.card_type_uuid,
                  card_material_code: null,
                  card_number: null,
                  card_identifiers: [
                    {
                      card_identifier_type_code:
                        defaultEmployeeCard?.default_card_identifier_type_code,
                      sn: {
                        base_10: null,
                        base_16: null,
                        string: this.employee.card.sn,
                      },
                      default_display_encoding: {
                        sn_base_10: false,
                        sn_base_16: false,
                        sn_string: true,
                      },
                      is_base_10_16_locked: true,
                      issue_datetime: null,
                      expire_datetime: null,
                      freeze_datetime: null,
                      discard_datetime: null,
                    },
                  ],
                },
              })
            )
          }

          if (this.employeeInit.card.sn && !this.employee.card.sn) {
            // delete card
            cardApiPutList.push(
              this.deleteCard({
                company_uuid,
                card_uuid: this.employee.card.card_uuid,
              })
            )
          }

          const biometricApiPutList = []
          const faceBiometricInit = this.employeeInit.biometric.find(
            (e) => e.biometric_code === 'face'
          )
          const faceBiometric =
            this.$store.state.employee.employeeBiometric.find(
              (e) => e.biometric_code === 'face'
            )
          if (
            JSON.stringify(faceBiometricInit) !== JSON.stringify(faceBiometric)
          ) {
            if (faceBiometric.biometric_property.length > 0) {
              // edit face biometric
              faceBiometric.biometric_property.forEach((face) => {
                biometricApiPutList.push(
                  this.$store.dispatch('employee/editEmployeeBiometric', {
                    company_uuid,
                    employee_uuid: this.employee.employee_uuid,
                    biometric_property_code: face.biometric_property_code,
                    body: {
                      ...face.employee_biometric,
                    },
                  })
                )
              })
            }
            if (faceBiometric.biometric_property.length === 0) {
              // delete face biometric
              faceBiometricInit.biometric_property.forEach((face) => {
                biometricApiPutList.push(
                  this.$store.dispatch('employee/deleteEmployeeBiometric', {
                    company_uuid,
                    employee_uuid: this.employee.employee_uuid,
                    biometric_property_code: face.biometric_property_code,
                  })
                )
              })
            }
          }
          const fingerInit = this.employeeInit.biometric.find(
            (e) => e.biometric_code === 'fingerprint_secugen'
          )
          const fingerInitSecugen1 = fingerInit?.biometric_property.find(
            (e) => e.biometric_property_code === 'fingerprint_secugen_1'
          )
          const fingerInitSecugen2 = fingerInit?.biometric_property.find(
            (e) => e.biometric_property_code === 'fingerprint_secugen_2'
          )
          const finger = this.$store.state.employee.employeeBiometric.find(
            (e) => e.biometric_code === 'fingerprint_secugen'
          )
          const fingerSecugen1 = finger?.biometric_property.find(
            (e) => e.biometric_property_code === 'fingerprint_secugen_1'
          )
          const fingerSecugen2 = finger?.biometric_property.find(
            (e) => e.biometric_property_code === 'fingerprint_secugen_2'
          )
          if (JSON.stringify(fingerInit) !== JSON.stringify(finger)) {
            if (fingerInitSecugen1 && !fingerSecugen1) {
              // delete finger secugen 1
              biometricApiPutList.push(
                this.$store.dispatch('employee/deleteEmployeeBiometric', {
                  company_uuid,
                  employee_uuid: this.employee.employee_uuid,
                  biometric_property_code: 'fingerprint_secugen_1',
                })
              )
            }
            if (fingerInitSecugen2 && !fingerSecugen2) {
              // delete finger secugen 2
              biometricApiPutList.push(
                this.$store.dispatch('employee/deleteEmployeeBiometric', {
                  company_uuid,
                  employee_uuid: this.employee.employee_uuid,
                  biometric_property_code: 'fingerprint_secugen_2',
                })
              )
            }
            if (fingerSecugen1 !== fingerInitSecugen1) {
              // edit finger secugen 1
              biometricApiPutList.push(
                this.$store.dispatch('employee/editEmployeeBiometric', {
                  company_uuid,
                  employee_uuid: this.employee.employee_uuid,
                  biometric_property_code:
                    fingerSecugen1.biometric_property_code,
                  body: {
                    ...fingerSecugen1.employee_biometric,
                  },
                })
              )
            }
            if (fingerSecugen2 !== fingerInitSecugen2) {
              // edit finger secugen 2
              biometricApiPutList.push(
                this.$store.dispatch('employee/editEmployeeBiometric', {
                  company_uuid,
                  employee_uuid: this.employee.employee_uuid,
                  biometric_property_code:
                    fingerSecugen2.biometric_property_code,
                  body: {
                    ...fingerSecugen2.employee_biometric,
                  },
                })
              )
            }
          }

          await Promise.all([
            ...employeeApiPutList,
            ...cardApiPutList,
            ...biometricApiPutList,
          ])

          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.fileImage = null
          this.uploadFilePreview = null
          this.serialValid = true
          this.serialMessageError = ''

          this.$emit('formActionCompleted', this.formAction)
        } catch (error) {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    onClose() {
      if (this.isEmployeeDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.onReset()
      }
    },
    onReset() {
      this.$refs.form.resetValidation()
      this.fileImage = null
      this.uploadFilePreview = null
      this.serialValid = true
      this.serialMessageError = ''

      this.accessAuthoritiesSelected = []

      this.$emit('onReset', this.formAction)
    },
  },
}
</script>
